import React, { Component, useEffect, useState } from "react";
import Form from "../comman/form";
import { Modal, Button } from "react-bootstrap";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import UploadDocument from "../comman/UploadDocument";
import auth, { getCurrentUser } from "../services/authService";
import config from "../config.json";
import WorkflowElement from "../app/components/WorkflowElement";
import { useDispatch, useSelector } from "react-redux";
import {
  getComplianceBprmForm,
  getCurrentComplianceWorkflowTask,
  getStartedComplianceAppData,
  loadComplianceBprmForm,
  loadComplianceCurrentWorkflowTask,
  startComplianceApplication,
} from "../app/store/complianceReports";

const AddComplaince = (props) => {
  const { showHideCompliance, handleShowHideCompliance, type, selectedObj } =
    props;

  const [workflowTask, setWorkflowTask] = useState(null);
  const [btnProcess, setBtnProcess] = useState(false);
  const [reqCount, setReqCount] = useState(0);
  const [apiCallCount, setApiCallCount] = useState(0);
  const [workflowFormData, setWorkflowFormData] = useState(null);
  const [documentInfo, setDocumentInfo] = useState({
    docType: "compliance",
    updType: "compliance",
    message: "Compliance Document",
  });
  const [wfForm, setWfForm] = useState(null);

  const compliacneAppStartedDataSelector = useSelector(
    getStartedComplianceAppData,
  );
  const complianceCurrentWorkflowTaskSelector = useSelector(
    getCurrentComplianceWorkflowTask,
  );
  const complianceBprmFormSelector = useSelector(getComplianceBprmForm);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedObj) {
      const data = {};
      data["compliance.Id"] = selectedObj.id;
      data["compliance.Name"] = selectedObj.name;
      data["compliance.Year"] = selectedObj.year;
      data["compliance.Total_Invoice_Amt"] = selectedObj.totalInvoiceAmount;
      data["compliance.Total_Paid_Amt"] = selectedObj.totalPaidAmount;
      data["compliance.Total_Balance_Amt"] = selectedObj.totalDueAmount;
      if (type === "w2")
        data["compliance.Notes"] =
          "Attached is your previous year's W2 Wage and Tax statement.";
      else
        data["compliance.Notes"] =
          "Attached is your previous year's 1099-NEC statement.";
      setWorkflowFormData(data);
    }
  }, [selectedObj]);

  const handleRunApplication = () => {
    setBtnProcess(true);
    const newApplication = {
      workflowId: config.workflowsIds.compliance.subcontractor,
      performerId: parseInt(currentUser.id),
      applicationId: 1,
    };
    dispatch(startComplianceApplication(newApplication));
  };

  useEffect(() => {
    if (compliacneAppStartedDataSelector?.ciid > 0 && reqCount === 0) {
      setTimeout(() => {
        dispatch(
          loadComplianceCurrentWorkflowTask(compliacneAppStartedDataSelector),
        );
        setReqCount(1);
      }, 3000);
    }
  }, [compliacneAppStartedDataSelector]);

  useEffect(() => {
    if (
      complianceCurrentWorkflowTaskSelector?.formId === null &&
      reqCount <= 3
    ) {
      setTimeout(async () => {
        dispatch(
          loadComplianceCurrentWorkflowTask(compliacneAppStartedDataSelector),
        );
        const rqCount = reqCount + 1;
        setReqCount(rqCount);
      }, 3000);
    } else if (complianceCurrentWorkflowTaskSelector?.wiid > 0) {
      setWorkflowTask(complianceCurrentWorkflowTaskSelector);
      setBtnProcess(false);
      dispatch(
        loadComplianceBprmForm(complianceCurrentWorkflowTaskSelector.formId),
      );
    } else if (reqCount >= 3) {
      handleShowHideCompliance("", "save");
    }
  }, [complianceCurrentWorkflowTaskSelector]);

  const handleNextTask = () => {
    setTimeout(() => {
      dispatch(loadComplianceCurrentWorkflowTask(workflowTask));
      setReqCount(1);
    }, 3000);
  };

  useEffect(() => {
    setWfForm(complianceBprmFormSelector);
  }, [complianceBprmFormSelector]);

  let notes = "";
  if (type === "w2")
    notes = "Attached is your previous year's W2 Wage and Tax statement.";
  else notes = "Attached is your previous year's 1099-NEC statement.";

  const modalTitle = type === "w2" ? "Upload W2 Statement" : "Upload 1099-NEC";
  const modalIcon = type === "w2" ? "fa-file-text-o" : "fa-file-o";
  const badgeLabel = type === "w2" ? "W2" : "1099-NEC";
  const modalDescription = type === "w2"
    ? "Upload and process W2 Wage and Tax statements for compliance records."
    : "Upload and process 1099-NEC statements for subcontractor compliance.";

  const handleClose = () => handleShowHideCompliance("", "");

  return (
    <React.Fragment>
      <Modal
        show={showHideCompliance}
        onHide={handleClose}
        size="lg"
        dialogClassName="ac-compliance-modal"
        centered
      >
        <style>{`
          /* Ensure the modal and backdrop are on top of the sidebar (1050) and header (1060) */
          .ac-compliance-modal + .modal-backdrop,
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }

          /* Glassmorphic backdrop filter and blur */
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }

          /* Spring-like transition for scale-in animation */
          .modal.fade .ac-compliance-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .ac-compliance-modal.modal-dialog {
            transform: scale(1) !important;
          }

          .ac-compliance-modal {
            --task-accent: #4f46e5;
            --task-soft: #eef2ff;
          }

          .ac-compliance-modal .modal-content {
            border-radius: 12px !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            border: none !important;
          }
          .ac-compliance-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 24px 28px 20px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .ac-compliance-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }
          .ac-compliance-modal .ac-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 14px !important;
            width: 100% !important;
          }
          .ac-compliance-modal .ac-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }
          .ac-compliance-modal .ac-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .ac-compliance-modal .ac-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            min-width: 0 !important;
            padding-top: 4px !important;
          }
          .ac-compliance-modal .ac-header-icon {
            width: 52px !important;
            height: 52px !important;
            min-height: 52px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }
          .ac-compliance-modal .ac-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }
          .ac-compliance-modal .ac-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 12px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .ac-compliance-modal .ac-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            background: var(--task-soft) !important;
            color: var(--task-accent) !important;
            border: 1px solid #e2e8f0 !important;
          }
          .ac-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 10px 12px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .ac-meta-desc {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.4 !important;
          }
          .ac-meta-desc i {
            color: var(--task-accent) !important;
          }
          .ac-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 5px 10px !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            border: 1px solid #e2e8f0 !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
          }
          .ac-meta-chip i {
            color: var(--task-accent) !important;
            font-size: 11px !important;
          }
          .ac-meta-divider {
            width: 1px !important;
            height: 16px !important;
            background: #cbd5e1 !important;
            margin: 0 4px !important;
          }

          /* Premium Header Close Button */
          .ac-compliance-modal .ac-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .ac-compliance-modal .ac-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .ac-compliance-modal .ac-action-btn:active {
            transform: translateY(0) !important;
          }
          .ac-compliance-modal .ac-action-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
            transition: color 0.2s ease !important;
          }
          .ac-compliance-modal .ac-action-btn:hover i {
            color: #ef4444 !important;
          }

          .ac-compliance-modal .modal-body {
            padding: 24px !important;
            background: #ffffff !important;
            max-height: calc(100vh - 220px) !important;
            overflow-y: auto !important;
          }

          /* Custom scrollbar for modal body */
          .ac-compliance-modal .modal-body::-webkit-scrollbar {
            width: 6px !important;
            height: 6px !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-track {
            background: transparent !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-thumb {
            background: #cbd5e1 !important;
            border-radius: 4px !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-thumb:hover {
            background: #94a3b8 !important;
          }

          /* Upload prompt card */
          .ac-compliance-modal .ac-upload-card {
            display: flex !important;
            align-items: center !important;
            gap: 16px !important;
            padding: 20px 24px !important;
            background: linear-gradient(135deg, var(--task-soft) 0%, #ffffff 100%) !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 10px !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
          }
          .ac-compliance-modal .ac-upload-card-icon {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 44px !important;
            height: 44px !important;
            border-radius: 10px !important;
            background: #ffffff !important;
            border: 1px solid #e2e8f0 !important;
            color: var(--task-accent) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
            box-shadow: 0 2px 6px rgba(0,0,0,0.04) !important;
          }
          .ac-compliance-modal .ac-upload-card-body {
            display: flex !important;
            flex-direction: column !important;
            gap: 10px !important;
            flex: 1 !important;
          }
          .ac-compliance-modal .ac-upload-card-text {
            font-size: 13px !important;
            color: #334155 !important;
            font-weight: 500 !important;
            line-height: 1.5 !important;
          }
          .ac-compliance-modal .ac-upload-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            align-self: flex-start !important;
            padding: 9px 20px !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.03em !important;
            color: #ffffff !important;
            background: var(--task-accent) !important;
            border: none !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3) !important;
            outline: none !important;
          }
          .ac-compliance-modal .ac-upload-btn:hover {
            background: #4338ca !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3) !important;
          }
          .ac-compliance-modal .ac-upload-btn:active {
            transform: translateY(0) !important;
          }
          .ac-compliance-modal .ac-upload-btn:disabled {
            opacity: 0.6 !important;
            cursor: not-allowed !important;
            transform: none !important;
          }

          /* General form overrides inside the compliance modal for modern rich UI */
          .ac-compliance-modal .modal-body label,
          .ac-compliance-modal .modal-body .control-label {
            font-size: 11px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            margin-bottom: 6px !important;
          }
          .ac-compliance-modal .modal-body input[type="text"],
          .ac-compliance-modal .modal-body input[type="email"],
          .ac-compliance-modal .modal-body input[type="date"],
          .ac-compliance-modal .modal-body input[type="time"],
          .ac-compliance-modal .modal-body select,
          .ac-compliance-modal .modal-body textarea,
          .ac-compliance-modal .modal-body .form-control {
            font-size: 12px !important;
            color: #0f172a !important;
            background-color: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            padding: 8px 12px !important;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
            transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
            outline: none !important;
          }
          /* Restore left padding for fields inside wf-input-wrap so the
             absolutely-positioned icon doesn't overlap text/placeholder */
          .ac-compliance-modal .modal-body .wf-input-wrap .form-control,
          .ac-compliance-modal .modal-body .wf-input-wrap input[type="text"],
          .ac-compliance-modal .modal-body .wf-input-wrap select,
          .ac-compliance-modal .modal-body .wf-input-wrap textarea {
            padding-left: 35px !important;
          }
          /* Textarea icon should sit near the top, not vertically centered */
          .ac-compliance-modal .modal-body .wf-input-wrap:has(textarea) .wf-input-icon {
            top: 14px !important;
            transform: none !important;
          }
          .ac-compliance-modal .modal-body input:focus,
          .ac-compliance-modal .modal-body select:focus,
          .ac-compliance-modal .modal-body textarea:focus,
          .ac-compliance-modal .modal-body .form-control:focus {
            border-color: #4f46e5 !important;
            box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1), 0 1px 2px rgba(0,0,0,0.05) !important;
            outline: none !important;
          }

          /* Modernized tables inside compliance modal */
          .ac-compliance-modal .modal-body table.table,
          .ac-compliance-modal .modal-body .table {
            width: 100% !important;
            margin-bottom: 1rem !important;
            color: #334155 !important;
            border-collapse: separate !important;
            border-spacing: 0 !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.02) !important;
          }
          .ac-compliance-modal .modal-body table.table th,
          .ac-compliance-modal .modal-body .table th {
            background-color: #f8fafc !important;
            color: #475569 !important;
            font-weight: 700 !important;
            font-size: 11px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.03em !important;
            padding: 10px 14px !important;
            border-bottom: 1px solid #e2e8f0 !important;
            border-top: none !important;
          }
          .ac-compliance-modal .modal-body table.table td,
          .ac-compliance-modal .modal-body .table td {
            padding: 10px 14px !important;
            font-size: 12px !important;
            vertical-align: middle !important;
            border-bottom: 1px solid #f1f5f9 !important;
            border-top: none !important;
            background: #ffffff !important;
          }
          .ac-compliance-modal .modal-body table.table tr:last-child td,
          .ac-compliance-modal .modal-body .table tr:last-child td {
            border-bottom: none !important;
          }
          .ac-compliance-modal .modal-body table.table tbody tr:hover td,
          .ac-compliance-modal .modal-body .table tbody tr:hover td {
            background-color: #f8fafc !important;
          }

          /* Upgrade internal buttons inside forms */
          .ac-compliance-modal .modal-body .btn,
          .ac-compliance-modal .modal-body button.btn-primary,
          .ac-compliance-modal .modal-body button.btn-default,
          .ac-compliance-modal .modal-body button.btn-success {
            padding: 7px 12px !important;
            font-size: 11px !important;
            font-weight: 700 !important;
            border-radius: 6px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            transition: all 0.2s ease !important;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
          }
          .ac-compliance-modal .modal-body .btn-primary {
            background-color: #4f46e5 !important;
            border-color: #4f46e5 !important;
            color: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .btn-primary:hover,
          .ac-compliance-modal .modal-body .btn-primary:focus {
            opacity: 0.9 !important;
            box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1) !important;
          }
          .ac-compliance-modal .modal-body .btn-success {
            background-color: #10b981 !important;
            border-color: #10b981 !important;
            color: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .btn-success:hover {
            background-color: #059669 !important;
            border-color: #059669 !important;
          }
          .ac-compliance-modal .modal-body .btn-default {
            background-color: #f1f5f9 !important;
            border-color: #cbd5e1 !important;
            color: #475569 !important;
          }
          .ac-compliance-modal .modal-body .btn-default:hover {
            background-color: #e2e8f0 !important;
            color: #334155 !important;
          }

          /* Card and section layout upgrades */
          .ac-compliance-modal .modal-body .card,
          .ac-compliance-modal .modal-body .panel {
            border: 1px solid #e2e8f0 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.02) !important;
            overflow: hidden !important;
            margin-bottom: 16px !important;
            background: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .card-header,
          .ac-compliance-modal .modal-body .panel-heading {
            background: #f8fafc !important;
            border-bottom: 1px solid #e2e8f0 !important;
            padding: 10px 16px !important;
            font-weight: 700 !important;
            font-size: 12px !important;
            color: #334155 !important;
          }
          .ac-compliance-modal .modal-body .card-body,
          .ac-compliance-modal .modal-body .panel-body {
            padding: 16px !important;
          }

          /* Premium Modal Footer */
          .ac-compliance-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
          }
          .ac-compliance-modal .ac-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .ac-compliance-modal .ac-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .ac-compliance-modal .ac-footer-close-btn:active {
            transform: translateY(0) !important;
          }
          .ac-compliance-modal .ac-footer-close-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .ac-compliance-modal .ac-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
        `}</style>
        <Modal.Header>
          <div className="ac-header-shell">
            <div className="ac-header-top">
              <div className="ac-header-main">
                <i className={`ac-header-icon fa ${modalIcon}`} aria-hidden="true" />
                <div className="ac-header-copy">
                  <h2 className="ac-modal-title">
                    <span className="ac-modal-title-text">
                      <span>{modalTitle}</span>
                      <span className="ac-modal-title-badge">
                        {badgeLabel}
                      </span>
                    </span>
                  </h2>
                  <div className="ac-modal-meta-row">
                    {selectedObj?.name && (
                      <span className="ac-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {selectedObj.name}
                      </span>
                    )}
                    {selectedObj?.name && modalDescription && (
                      <span className="ac-meta-divider" />
                    )}
                    <span className="ac-meta-desc">
                      <i className="fa fa-info-circle" aria-hidden="true" /> {modalDescription}
                    </span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="ac-action-btn"
                onClick={handleClose}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!wfForm && (
            <div className="ac-upload-card">
              <div className="ac-upload-card-icon">
                <i className="fa fa-cloud-upload" aria-hidden="true" />
              </div>
              <div className="ac-upload-card-body">
                <div className="ac-upload-card-text">{notes}</div>
                <button
                  className="ac-upload-btn"
                  disabled={btnProcess}
                  onClick={() => handleRunApplication()}
                >
                  {btnProcess && <i className="fa fa-spinner fa-spin"></i>}
                  <i className="fa fa-upload" aria-hidden="true"></i>
                  Upload Document
                </button>
              </div>
            </div>
          )}

          {wfForm && (
            <div className="col-md-12">
              <WorkflowElement
                wfTask={workflowTask}
                wfForm={wfForm}
                handleNextTask={handleNextTask}
                workflowFormData={workflowFormData}
                documentInfo={documentInfo}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="ac-footer-close-btn"
            onClick={handleClose}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AddComplaince;
